<template>
  <div
    class="create-wraper"
    :class="{
      [`create-wraper--${createRenderType}`]: true,
    }"
  >
    <CreateEdit
      @click.native="
        () => {
          switchCurOpModule('createEdit', true);
        }
      "
      ref="refCreateEdit"
    ></CreateEdit>
    <div
      class="create-result flex1"
      @click.native="
        () => {
          switchCurOpModule('createResult', false);
        }
      "
    >
      <GenerateResult @restore="doRestore"></GenerateResult>
    </div>
  </div>
</template>
<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
  getCurrentInstance,
} from "vue";

import {
  $$language,
  $$t,
  $$registLanguageChangeListener,
  $$removeLanguageChangeListener,
} from "@/i18n/i18n.js";
import CreateEdit from "@/page/create/createEdit.vue";
import GenerateResult from "./feedList/generateResult.vue";

import useDraftDataStore from "@/store/create/draftDataStore.js";
const draftDataStore = useDraftDataStore();
import useFeedListStore from "@/store/create/feedListDataStore.js";
import useUserDataStore from "@/store/userDataStore.js";
import { storeToRefs } from "pinia";
import useDiverStore from "@/store/driverStore.js";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import usePresetSourceDataStore from "@/store/create/presetSourceDataStore.js";
import useDialogStore from "@/store/dialogStore.js";

const driverStore = useDiverStore();
const createLayoutStore = useCreateLayoutStore();
const presetSourceDataStore = usePresetSourceDataStore();
const dialogStore = useDialogStore();

const { curDriverKey } = storeToRefs(driverStore);
const {
  createEditMode,
  createRenderType,
  create_createEditOpenState,
  nocreate_createEditOpenState,
} = storeToRefs(createLayoutStore);

const feedListDataStore = useFeedListStore();
const userDataStore = useUserDataStore();
const { isLogin } = storeToRefs(userDataStore);

const globalProperties =
  getCurrentInstance()?.appContext.config.globalProperties;

const Router = useRouter();
const route = useRoute();
const refCreateEdit = ref(null);

const showData = ref({});

const props = defineProps({});
const emits = defineEmits([]);
const renderData = reactive({});


const switchCurOpModule = (key, isOpen) => {
  createLayoutStore.setCurOpModule(key, isOpen);
};

const doRestore = () => {
  refCreateEdit.value?.openEdit();
};

onMounted(async () => {
  // globalProperties.logViewEvent("create");
  if (userDataStore.isLogin) {
    userDataStore.refreshUserAccount();
  }
  presetSourceDataStore.getPresetSourceData();
  if (!dialogStore.isLoading && !dialogStore.inviteFinishedDialog && !dialogStore.recallMailDialog && !dialogStore.vocalDialog && !dialogStore.advGuideDialog && !dialogStore.whatsNewDialog) {
    dialogStore.getPopupShow()
  }
  // $$registLanguageChangeListener(rerenderLyric);
});

watch(
  () => userDataStore.appLanguage,
  (newVal) => {
    nextTick().then(() => {
      presetSourceDataStore.getPresetSourceData(true);
    });
  }
);

onUnmounted(() => {
  // $$removeLanguageChangeListener(rerenderLyric);
});
</script>
<style lang="scss">
.create-wraper {
  margin: 0 0 0 20px;
  height: 100%;
  display: flex;
  .create-result {
    height: 100%;
  }
  &.create-wraper--mobile {
    margin: 0;
    display: block;
  }
}
.main-page {
  &.main-page--create,
  &.main-page--createIndex,
  &.main-page--editor {
    .wrapper.show-player-create {
      .wrapper-player-create {
        display: none;
      }
      .wrapper-create {
        display: block;
        height: 80px;
      }
    }
  }
}
</style>
